'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var storage = require('./storage.js');

const THEME_KEY = "dark";
function initializeTheme() {
  setTheme(getTheme());
}
function getTheme() {
  return storage.getItem(THEME_KEY) ? "dark" : "light";
}
function setTheme(theme) {
  document.documentElement.dataset.theme = theme;
  storage.setItem(THEME_KEY, theme === "dark");
}

exports.THEME_KEY = THEME_KEY;
exports.getTheme = getTheme;
exports.initializeTheme = initializeTheme;
exports.setTheme = setTheme;
